const _colors = {
  warning: '#ffd24d',
  warningDark: '#BD8C28',
  blue: '#0096d6',
  blueDark: '#075782',
  purple: '#7d3894',
  grayBorder: '#c7c7c7',
  pink: '#ffbdc9',
  blueVeryLight: '#cceaf7',
  blueGem: '#4B4096',
  blueLight: '#99d5ee',
  blueBgSelect: 'rgba(0, 150, 214, 0.08)',
  blueBgHover: 'rgba(0, 150, 214, 0.04)',
  greenBg: 'rgba(0, 176, 79, 0.4)',
  hoverBgGreen: 'rgba(0, 157, 105, 0.08)',
  disabledBorderPurple: 'rgba(125, 56, 148, 0.5)',
  hoverBorderBlueGem: 'rgba(75, 64, 150, 0.08)',
  lavender: '#E3D7FD',

  gray: '#8f8f8f',
  black: '#000000',
  grayDark: 'rgba(0, 0, 0, 0.54)',
  grayText: '#56585a',
  grayLight: '#e8e8e8',
  grayBg: '#f5f5f5',
  green: '#00b04f',
  greenDark: '#007e54',
  lightGreen: '#c3ffde',
  greenStatus: '#009d69',
  white: '#ffffff',
  blackPrimary: 'rgba(0, 0, 0, 0.87)',

  yellow: '#FFD24D',
  lightYellow: '#f8fab8',
  lightGray: '#e0e0e0ff',
  lightBlue: '#C9E0FC',
  mediumGray: '#a6a4a4ff',
  red: '#d6002a',
  redLight: '#ff002a',
  redDark: '#8c031c',
  purpleLight: '#c5a1d4',
  peachPuff: '#ffdab9',
  whitesmoke: '#f5f5f5',
  exportColor: 'rgba(0, 176, 79)',
  exportBorderColor: 'rgba(0, 176, 79, 0.5)',
  browseFileLink: '#075782',
  bannerAccordionBorderColor: '#D9D9D9',
  Expert: '#518CFF',
  Typical: '#7FADBE',
  Floor: '#E39922',
  Top25: '#FD9C5C',
  Median: '#027D4B',
  Bottom25: '#296EF9',
  BidDesk: '#518CFF',
  PricingManager: '#FF5050',
  CountryCategory: '#01AE6A',

  agGridDynamicOGM: '#008000',
  agGridDynamicColor1: '#3AACDF',
  agGridDynamicColor2: '#F36E6E',
  agGridDynamicColor3: '#F2AE82',
  agGridDynamicColor4: '#A27CB9',
  agGridDynamicColor5: '#4DB8A0',

  defusedWhite: '#FFFFFFB0',
}

export default _colors
